<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增商品</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button type="warning" size="small" style="margin-right: 5px"
						@click="goodListFunc(row.id)">章节管理</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="商品名称">
					<Input v-model="addForm.title" maxlength="100" placeholder="请输入商品名称" clearable></Input>
				</FormItem>
				<FormItem label="商品介绍">
					<Input v-model="addForm.intro" maxlength="100" placeholder="请输入商品介绍" clearable></Input>
				</FormItem>
				<FormItem label="图文详情">
					<Input v-model="addForm.content" maxlength="100" placeholder="请输入图文详情" clearable></Input>
					<Upload :action="uploadFile" name="file" :on-success="contentImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="图片" prop="img">
					<Upload :action="uploadFile" name="file" :on-success="logoImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="正常价格（元）">
					<Input v-model="addForm.price" maxlength="100" placeholder="请输入正常价格" clearable></Input>
				</FormItem>
				<FormItem label="划线价格（元）">
					<Input v-model="addForm.linePrice" maxlength="100" placeholder="请输入划线价格" clearable></Input>
				</FormItem>
				<FormItem label="会员价（元）">
					<Input v-model="addForm.memberPrice" maxlength="100" placeholder="请输入会员价" clearable></Input>
				</FormItem>
				<FormItem label="排序">
					<Input v-model="addForm.sortIndex" type="number" maxlength="100" placeholder="排序越小越靠前"
						clearable></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addForm.status==1" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>
		<Modal v-model="goodShow" :title="addForm.id?'编辑':'新增'" width="1600">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addGoodShowFunc">新增章节</Button>
			</TableFuncs>
			<Table border :columns="goodColumn" :loading="loading" :data="goodList" ref="goodList" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editGoodsData(row)">编辑</Button>
				</template>
			</Table>
		</Modal>
		<Modal v-model="addGoodShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addGoodForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="章节标题">
					<Input v-model="addGoodForm.title" maxlength="100" placeholder="请输入章节标题" clearable></Input>
				</FormItem>
				<FormItem label="类型" prop="type">
					<RadioGroup v-model="addGoodForm.type">
						<Radio label="1">文档</Radio>
						<Radio label="2">视频</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="文件" prop="img">
					<Upload :action="uploadFile" name="file" :on-success="goodImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</FormItem>
				<FormItem label="排序">
					<Input v-model="addGoodForm.sortIndex" type="number" maxlength="100" placeholder="排序越小越靠前"
						clearable></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addGoodForm.status==1" size="large" @on-change="changeGoodStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditGoodData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				goodShow: false,
				addGoodShow: false,
				goodList: [],
				addForm: {
					id: undefined,
					sortIndex: '',
					img: '',
					title: undefined,
					intro: undefined,
					content: '',
					status: 0,
					price: 0,
					linePrice: 0,
					memberPrice: 0,
				},
				addGoodForm: {
					id: undefined,
					catalogId: undefined,
					img: '',
					title: undefined,
					fileUrl: undefined,
					type: '1',
					status: 0,
					sortIndex: 0,
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '排序',
						width: 150,
						key: 'sortIndex',
						align: 'center'
					},
					{
						title: '图片',
						width: 350,
						key: 'img',
						align: 'center'
					},
					{
						title: '商品名称',
						width: 250,
						key: 'title',
						align: 'center'
					},
					{
						title: '商品介绍',
						width: 350,
						key: 'intro',
						align: 'center'
					},
					{
						title: '图文详情',
						width: 350,
						key: 'content',
						align: 'center'
					},
					{
						title: '正常价格',
						width: 150,
						key: 'price',
						align: 'center'
					},
					{
						title: '划线价格',
						width: 150,
						key: 'linePrice',
						align: 'center'
					},
					{
						title: '会员价',
						width: 150,
						key: 'memberPrice',
						align: 'center'
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == 1) {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},
			goodColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '排序',
						width: 150,
						key: 'sortIndex',
						align: 'center'
					},
					{
						title: '章节标题',
						width: 350,
						key: 'title',
						align: 'center'
					},
					{
						title: '类型',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.type;
							if (val === '1') {
								name = '文档'
							} else {
								name = '视频'
							}
							return h('span', name)
						}
					},
					{
						title: '文件链接',
						width: 250,
						key: 'fileUrl',
						align: 'center'
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == 1) {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			}

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.goodCatalogPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			logoImgBack(response, file, fileList) {
				this.addForm.img = response.data.url
			},
			contentImgBack(response, file, fileList) {
				this.addForm.content = response.data.url
			},
			goodImgBack(response, file, fileList) {
				this.addGoodForm.fileUrl = response.data.url
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					sortIndex: '',
					img: '',
					title: undefined,
					intro: undefined,
					content: '',
					status: 0,
					price: 0,
					linePrice: 0,
					memberPrice: 0,
				}
				this.addJobShow = true
			},
			addGoodShowFunc() {
				this.addGoodForm = {
					id: undefined,
					catalogId: this.addGoodForm.catalogId,
					img: '',
					title: undefined,
					fileUrl: undefined,
					type: '1',
					status: 0,
					sortIndex: 0,
				}
				this.addGoodShow = true
			},
			addOrEditData(row) {
				const that = this
				let addData = this.addForm
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.goodCatalogAdd(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			addOrEditGoodData(row) {
				const that = this
				let addData = this.addGoodForm
				that.$refs['addGoodForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.goodAdd(addData)
							.then(res => {
								that.addGoodShow = false
								api.statistics
									.goodList({
										'id': this.addGoodForm.catalogId,
									})
									.then(res => {
										that.goodList = res.data
									})
							})
					}
				})
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			changeGoodStatus(state, data){
				this.addGoodForm.status = state ? '1' : '0'
			},
			goodListFunc(id) {
				const that = this
				this.addGoodForm.catalogId = id
				api.statistics
					.goodList({
						'id': id,
					})
					.then(res => {
						this.goodList = res.data
						this.goodShow = true
					})
			},

			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},
			editGoodsData(data) {
				this.addGoodForm = data
				this.addGoodShow = true
			},

		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>